:host {
  @include font(bold);

  align-items: center;
  background: var(--ux-badge-background);
  border-radius: var(--ux-badge-border-radius);
  color: $color-white;
  display: inline-flex;
  font-size: var(--ux-badge-font-size);
  justify-content: center;
  line-height: 1;
  min-height: 14px;
  min-width: 14px;
  text-align: center;
  padding: var(--ux-badge-padding-vertical) var(--ux-badge-padding-horizontal);
}
